import styled from 'styled-components'
import { TextFieldStyled } from '../TextField/TextField.styles'

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.inputBorderColour};
  border-radius: ${({ theme }) => theme.formControlBorderRadius};
  height: 50px;
  box-sizing: border-box;
  background-color: white;
  width: 100%;
  @media (min-width: 768px) {
    height: 60px;
  }

  :hover {
    outline: 2px solid ${({ theme }) => theme.inputHoverOutlineColour};
  }

  :has(:active) {
    border-color: ${({ theme }) => theme.inputActiveBorderColour};
  }
  :focus-within {
    outline-offset: 0px;
    outline: 2px solid ${({ theme }) => theme.inputFocusOutlineColour};
    border-color: ${({ theme }) => theme.inputFocusBorderColour};
  }
  :focus-within:has(:active) {
    outline: 1px solid ${({ theme }) => theme.inputActiveFocusOutlineColour};
  }
`

export const DateInputFieldWrapper = styled.div`
  width: 100%;
  ::after {
    position: absolute;
    content: '/';
    font-size: 32px;
    font-weight: ${({ theme }) => theme.fontWeight};
    color: #ccc;
    line-height: 50px;
  }

  @media (min-width: 768px) {
    ::after {
      line-height: 60px;
    }
  }
`

export const YearInputWrapper = styled.div`
  width: 100%;
`

export const DateInputField = styled.input`
  border: none;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  background-color: transparent;
  margin: 0;
  text-align: center;
  outline: none;
  border-radius: ${({ theme }) =>
    theme.formControlBorderRadius}; // needed for when autofill adds a bacground colour
  ::placeholder {
    color: ${({ theme }) => theme.durationOptions.primaryColour};
  }
`
